export enum TopicSourceType {
    SocialMedia = "Social Media",
    ReviewsAndUGC = "Reviews & UGC",
    NewsAndPublishers = "News & Publishers",
    Marketplace = "Marketplace",
    ECommerceBrands = "E-commerce Brands",
    BusinessServices = "Business Services",
    FinancialServices = "Financial Services",
    ConsumerServices = "Consumer Services",
    SearchAndDiscovery = "Search & Discovery",
    MyDomain = "My Domain",
    CompetitorDomains = "Competitor Domains",
    DirectCompetitors = "Direct Competitors",
    Other = "Other",
}

export interface ISourceType {
    name: TopicSourceType;
    share?: number;
}

export interface ISourceConfig {
    text: string;
    backgroundColor: string;
    textColor: string;
}
